<template>
  <div>
    <div ref="resumeChart"></div>
  </div>
</template>

<script>
import { makeChartOptions, makeChartObj, updateChartObj } from "@/utils/charts"

export default {
  name: "Resume",
  props: {
    resume: {
      type: Object
    }
  },
  data() {
    return {
      chart: null
    }
  },
  computed: {
    isThemeDark() {
      return this.$store.state.app.isThemeDark
    }
  },
  methods: {
    getChartOptions(series) {
      return makeChartOptions({
        chart: { height: 400, type: "line" },
        isThemeDark: this.isThemeDark,
        series: series,
        titleText: this.$t("views.statistics.distribution"),
        tooltip: { x: { format: "dd MMM yyyy" } },
        xaxis: { type: "datetime" }
      })
    },
    getSeries() {
      const inspectionsSeries = this.makeSerie(this.resume.inspections)
      const nonConformitiesSeries = this.makeSerie(this.resume.non_conformities)
      return [
        { name: "Inspections", data: inspectionsSeries },
        { name: "Nonconformities", data: nonConformitiesSeries }
      ]
    },
    makeChart() {
      const series = this.getSeries()
      const options = this.getChartOptions(series)
      this.chart = makeChartObj(this.$refs.resumeChart, options)
    },
    makeSerie(data) {
      const values = []
      data.forEach(e => values.push([e[0], e[1]]))
      return values
    },
    updateChart() {
      const series = this.getSeries()
      const options = this.getChartOptions(series)
      updateChartObj(this.chart, options)
    }
  },
  mounted() {
    this.makeChart()
  },
  watch: {
    resume: {
      deep: true,
      handler() {
        this.updateChart()
      }
    },
    isThemeDark: {
      handler() {
        this.updateChart()
      }
    }
  }
}
</script>
